import React, { useEffect, useState } from "react";
import { stripNumbers } from "../utils";

function AnimatedTextInput({
  value,
  onChange = null,
  id,
  isFocused = false,
  label,
  isDisabled = false,
  type = "text",
  isTextOnly = false,
}) {
  const [isActive, setActive] = useState(isFocused);
  const [textValue, setTextValue] = useState(value);

  const focused = () => {
    setActive(true);
  };
  const unFocused = () => {
    setActive(false);
  };
  const handleChange = (e) => {
    // TODO: Check if redundant
    // Seems like it is, do thorough testing
    const textValue = isTextOnly
      ? stripNumbers(e.target.value)
      : e.target.value;
    setTextValue(textValue);
    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    setTextValue(value);
  }, [value]);

  return (
    <div
      className={
        isActive || textValue ? "field_group field_lbl_active" : "field_group"
      }
    >
      <label className="field_lbl">{label}</label>
      <input
        type={type}
        className="field_input"
        placeholder=""
        value={textValue}
        autoFocus={isActive}
        onFocus={focused}
        onBlur={unFocused}
        onChange={handleChange}
        id={id}
        disabled={isDisabled}
        autoComplete="off"
      />
    </div>
  );
}

export default AnimatedTextInput;
